import React from 'react';
import {Route, BrowserRouter, Switch, Redirect} from 'react-router-dom';
import {App, LoginPage, RecoveryForm, ResetPassword, CommonDashboard, Voice} from './index';


export const AppRoute = () => {
    let prevURL = window.location.pathname;
    
    return <BrowserRouter>
        <Switch>
            <Route exact path="/" render={() => (
                <Redirect to="/login"/>
            )}/>
            <Route
                exact
                path='/login' render={() => (
                    <LoginPage prevURL={prevURL} />
                )} 
            />
            <Route exact path="/recovery" 
                render={() => (
                    <RecoveryForm prevURL={prevURL} />
                )} 
            />
            <Route exact path="/reset-password" 
                render={() => (
                    <ResetPassword prevURL={prevURL} />
                )} 
            />
            <Route exact path="/voice" 
                render={() => (
                    <Voice prevURL={prevURL} />
                )} 
            />
          
            <App>
                <Route path="/" component={CommonDashboard} />
            </App>
        </Switch>
    </BrowserRouter>
};



// WEBPACK FOOTER //
// ./src/app/routes/Routes.js